module.exports = __webpack_public_path__ + "media/images/teaser__experten-efb3c846b9d20d9364bb994b33ce3795.jpg";